import { Link } from 'react-router-dom';

import LocationSearch from 'components/locations/LocationSearch';
import Icon, { Icons } from 'components/common/icons/Icon';

function Header() {
  return (
    <header
      className="flex h-16 items-center justify-between border-b border-slate-300/70 px-4"
      data-testid="header"
    >
      <nav className="flex h-full basis-1/2 items-center sm:basis-1/4">
        <Link to="/" title="Weather">
          <img src="/favicon.png" alt="Logo" className="mr-2 h-6 w-6" />
        </Link>
        <div className="mr-3 text-xl">Weather</div>
      </nav>
      <div className="hidden basis-1/2 sm:block">
        <div className="mx-auto max-w-sm">
          <LocationSearch />
        </div>
      </div>
      <nav className="flex h-full basis-1/2 items-center justify-end sm:basis-1/4">
        <Link to="/settings" title="Settings">
          <Icon name={Icons.Gear} size="lg" fixedWidth className="ml-2" />
        </Link>
      </nav>
    </header>
  );
}

export default Header;
